import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de7e7f1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-image hover-overlay ripple",
  "data-mdb-ripple-color": "light"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#!" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mask" })
], -1))




export default /*#__PURE__*/_defineComponent({
  props: {
  cover: String,
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: props.cover,
      class: "img-fluid"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})